module.exports = __webpack_public_path__ + "static/media/parent.ce35a0b0.png";